import  {setCookie,getCookie,eraseCookie} from '../utils/index.js';

$(document).foundation();
const $windowWidth = $(window).width();
const header = {
  init() {
    this.responsiveClasses();
    //this.stickyHeader();
    this.stickySidebar();
    this.scrollEvents();
    this.slickSliders();
    this.filteredSliders();
    this.pushSlider();
    this.gridToMobileCarousel();
    this.toggleFunctions();
    this.hpVideo();
    this.accessibilityFunctions();
    this.accessibleNav();
    this.resizeEvents();
    this.pushFooterSlider();
    this.removeEmptyTags();
    this.loadEvents();
    this.toggleDescription();
  },

  toggleDescription(){
    /*$('.dining-image').on('click', function() {
      var description_id = $(this).attr('data-description-id');
      $('.dining-content'+description_id).removeClass('hidden');
      $(this).addClass('active');
      $('.active').removeClass('active');      
      $('.dining-images').find('.dining-content'+description_id).addClass('hidden');
    });*/

    $('.dining-images').find('.dining-image').on('click', function() {
      var description_id = $(this).attr('data-description-id'); 
      $('.active').removeClass('active');       
      $(this).addClass('active');
      $('.dining-images').find('.dining-image-modal').addClass('hidden');
      $('.dining-images').find('.dining-content'+description_id).removeClass('hidden');
    });
    $('.dining-images').find('.btn-close').on('click', function() {
      $('.active').removeClass('active');
      $('.dining-image-modal').addClass('hidden');
    });
    $('.press-room .load-more').on('click', function() {
      $('.loaded-group').slideToggle();
      var loadBtnTxt =  $.trim($('.load-more').text());
      if (loadBtnTxt == "Load More") {
        $(this).text('Load Less');
      } else {
        $(this).text('Load More');
      }
    });

  },
  stickyHeader() {
    var hdrHeight = Math.round($('.header').height());
    var mhHeight = Math.round($('.masthead').height());
    var scroll = $(window).scrollTop();
    if (
      $('body').hasClass('home') ||
      ($('body').hasClass('destination') && $(window).width() > 1024)
    ) {
      if (scroll >= mhHeight - hdrHeight) {
        $('.header').addClass('scrolled');
      }
      if (scroll <= mhHeight - hdrHeight - 1) {
        $('.header').removeClass('scrolled');
      }
    }
    if ($('body').hasClass('home') && $(window).width() < 1025) {
      if (scroll >= 335) {
        $('.header').addClass('scrolled');
      }
      if (scroll <= 334) {
        $('.header').removeClass('scrolled');
      }
    }
    if ($('body').hasClass('destination') && $(window).width() < 1025) {
      if (scroll >= 130) {
        $('.header').addClass('scrolled');
      }
      if (scroll <= 129) {
        $('.header').removeClass('scrolled');
      }
    }
  },

  stickySidebar() {
    var scroll = $(window).scrollTop();
    var hdrHeight;
    var mhHeight;
    $('body').hasClass('destination')
      ? (mhHeight = Math.round($('.masthead').height() - 60))
      : (mhHeight = Math.round($('.masthead').height() - 95));
    $('body').hasClass('destination')
      ? (hdrHeight = Math.round($('.header').height() - 60))
      : (hdrHeight = Math.round($('.header').height()));
    var contentHeight = Math.round($('#maincontent').innerHeight());
    if (
      $('body').hasClass('default') ||
      ($('body').hasClass('destination') && $(window).width() > 1024)
    ) {
      if (scroll > mhHeight + hdrHeight && scroll < contentHeight) {
        $('.sidebar')
          .addClass('sticky')
          .css({ height: contentHeight + 'px', top: hdrHeight + 'px' });
      }
      if (scroll < mhHeight + hdrHeight || scroll > contentHeight) {
        $('.sidebar')
          .removeClass('sticky')
          .css({ height: 'auto', top: 'auto' });
      }
    }
    if ($('body').hasClass('default') && $(window).width() < 1025) {
      $('.sidebar')
        .removeClass('sticky')
        .css({ height: 'auto', top: 'auto' });
    }
  },

  responsiveClasses() {
    var current_width = $(window).width();
    if (current_width < 768)
      $('html')
        .addClass('mobile')
        .removeClass('desktop tablet');

    if (current_width < 1025 && current_width > 767)
      $('html')
        .addClass('tablet')
        .removeClass('desktop mobile');

    if (current_width > 1024)
      $('html')
        .addClass('desktop')
        .removeClass('mobile tablet');
  },

  toggleFunctions() {
    // Mobile Menu Close
    $('.btn-close-menu').on('click', function() {
      $('body').removeClass('fixed');
      $('.top-bar#main-menu').fadeOut();
    });

    // Prevent Page Scroll when Mobile Menu is open
    $('.menu-icon').on('click', function() {
      $('body').addClass('fixed');
    });

    $('.menu-icon-property').on('click', function() {
      $('body').addClass('fixed');
      $('.property-navigation')
        .find('.menu-wrap')
        .fadeIn();
    });

    $('.btn-close-menu-property').on('click', function() {
      $('body').removeClass('fixed');
      $('.property-navigation')
        .find('.menu-wrap')
        .fadeOut();
    });

    $('.search-text-button').on("click", function(){
      setCookie('fromUsToNonUs',true,2);
     });
   
     $('.nav-global .submenu-toggle').attr('tabindex', '-1');
    $('.nav-global-title-bar .nav-global-menu-icon').on('click', function(e) {
      e.preventDefault();
      $(this).toggleClass('nav-global-btn-close-menu');
      $('body').toggleClass('fixed');
      $('.nav-global, .nav-global-scrim').toggleClass('active');
      if ($('.nav-global').hasClass('active')) {
        $('.nav-global a').attr('tabindex', '0');
        $('.closing-global-navigation').attr('tabindex', '0');
        $('.nav-global .submenu-toggle').attr('tabindex', '0');
      } else {
        $('.nav-global a').attr('tabindex', '-1');
        $('.closing-global-navigation').attr('tabindex', '-1');
        $('.nav-global .submenu-toggle').attr('tabindex', '-1');
      }
    });


    //toggle the component with class accordion-content
    $(".accordion-title").click(function() {
      if ($('.accordion-content').is(':visible')) {
        $(".accordion-content").slideUp(300);
        $(".plusminus").html('<span class="plus">+</span>');
      }
      if ($(this).next(".accordion-content").is(':visible')) {
        $(this).next(".accordion-content").slideUp(300);
        $(this).children(".plusminus").html('<span class="plus">+</span>');
      } else {
        $(this).next(".accordion-content").slideDown(300);
        $(this).children(".plusminus").html('<span class="minus">-</span>');
      }
    });
    
    //View Timeline
    $('.toggle-view-timeline').on('click', function() { 
      $('#modal-view-timeline')
        .fadeIn()
        .addClass('modal-console-open');
      $('body').addClass('modal-fixed');
    });

    // Close Find a hotel Modal Console
    $('#modal-view-timeline .btn-close').on('click', function() {
      $('.nav-global-btn-close-menu').click();

      $('#modal-view-timeline').fadeOut(300, function() {
        $(this).removeClass('modal-console-open');
      });
      $('body').removeClass('modal-fixed');
    });
    //View Timeline

    window.onload = function() {
     var fromNonUsToUs = getCookie("fromNonUsToUs");
      if(fromNonUsToUs) {
        $('#modal-find-a-hotel').addClass('modal-console-open');
        $('.home').addClass('modal-fixed');
        eraseCookie('fromNonUsToUs');
        setCookie('fromNonUsToUs',false,0);
       }
    }

    $('.is-accordion-submenu-parent .submenu-toggle').on('click', function() {
      $(this)
        .closest('.is-accordion-submenu-parent')
        .toggleClass('expanded');
    });

    $('.nav-global a').attr('tabindex', '-1');

    // Mobile Phone Menu Toggle
    $('.menu-phone-toggle').on('click', function(e) {
      e.preventDefault();
      $(this).toggleClass('expanded');
      $('.menu-phone-numbers').toggle();
    });

    // Launch Modal Console
    $('.modal-console-trigger').on('click', function() {
      $('#modal-console')
        .fadeIn()
        .addClass('modal-console-open');
      $('body').addClass('modal-fixed');
    });

    // Close Modal Console
    $('#modal-console .btn-close').on('click', function() {
      $('#modal-console').fadeOut(300, function() {
        $(this).removeClass('modal-console-open');
      });
      $('body').removeClass('modal-fixed');
    });

    //Skip/Scroll To to Main Content
    $('#skiptocontent').on('click', function() {
      var offset;
      $('body').hasClass('home') ? (offset = 170) : (offset = 70);
      $('html, body').animate(
        {
          scrollTop: $('#maincontent').offset().top - offset
        },
        500
      );
    });

    // Reset Toggle Element on Document click
    //$(document).click(function() {
    $(document).on('click touch', function () {
      header.resetToggle();
    });

    // Close Share menu when link is clicked
    $('.sm-link').on('click', function() {
      header.resetToggle();
    });

    // Tabbing outside of Toggle Content closes element
    $('.toggle-content').bind('focusout', function(e) {
      if (e.relatedTarget != null) {
        if (
          !e.relatedTarget.parentElement.classList.contains('toggle-content')
        ) {
          header.resetToggle();
        }
      }
    });

    $('.toggle-button').on('click', function(e) {
      e.stopPropagation();
      var button = $(this);
      var parent = button.closest('.toggle-parent');
      var content = parent.find('.toggle-content');
      button.add(parent).toggleClass('expanded');
      if (button.hasClass('expanded')) {
        button.attr('aria-expanded', 'true');
      } else {
        button.attr('aria-expanded', 'false');
      }
      content
        .find(
          'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled])'
        )
        .attr('tabindex', '0');
    });

    $('.back-to-top-experiences').on('click', () => {
      document.getElementById('find-a-hotel-tabs').scrollIntoView({
        block: 'end',
        inline: 'nearest'
      });
    });

    $('.check-availability-mobile').on('click', function() {
      $('body.destination')
        .addClass('fixed')
        .find('.sidebar')
        .addClass('modal');
    });

    $('.btn-close-modal-sidebar').on('click', function() {
      $('body.destination')
        .removeClass('fixed')
        .find('.sidebar')
        .removeClass('modal');
    });
    $(".featured-offers-widget .inner a, .featured-offers-widget .inner button").attr('tabindex','-1');
    $('.sidebar')
      .find('.special-offers-mobile')
      .on('click', function() {
        var $sidebar = $(this).closest('.sidebar');
        if ($(window).width() > 1024) {
          $sidebar.toggleClass('offers-active');
          $sidebar.find('.outside-field-submit').toggleClass('outside-submit');
        }
        if ($(window).width() < 1024) {
          $sidebar.removeClass('offers-active');
          $sidebar.find('.outside-field-submit').toggleClass('outside-submit');
        }
        if ($sidebar.hasClass('offers-active')) {
          $sidebar
            .find('.special-offers-text')
            .find('.toggle-text')
            .text('Hide');
            $(".featured-offers-widget .inner a, .featured-offers-widget .inner button").attr('tabindex','0');
        } else {
          $sidebar
            .find('.special-offers-text')
            .find('.toggle-text')
            .text('View');
            $(".featured-offers-widget .inner a, .featured-offers-widget .inner button").attr('tabindex','-1');
        }
      });

    $('.package-details').on('click', function(e) {
      e.preventDefault();
      var $el = $(this);
      var $pw = $el.closest('.package-wrapper');
      var $pl = $pw.find('.package-long');
      $pw.toggleClass('expanded');

      if ($pw.hasClass('expanded')) {
        $pl.slideDown();
        $el.text('Close');
      } else {
        $pl.slideUp();
        $el.text('View Details');
      }
    });
      

  },

  resetToggle() {
    if ($('.toggle-content').is(':visible')) {
      $('.toggle-parent, .toggle-button').removeClass('expanded');
      $('.toggle-content')
        .find(
          'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), button:not(".toggle-button")'
        )
        .attr('tabindex', '-1');
      $('.toggle-button').attr('aria-expanded', 'false');
    }
  },

  accessibilityFunctions() {
    $('.modify-wrap a, .field .submit').on('keyup', function(e) {
      if (e.key === 9 || e.keyCode === 9) {
        $('.promo-modify').removeClass('expanded');
        $('.promo-modify')
          .find(':input')
          .attr('tabindex', '-1');
      }
    });

    $('#modal-console')
      .find('.chat-trigger')
      .on('focusout', function() {
        $('#modal-console')
          .find('.btn-close')
          .trigger('click');
      });
  },

  accessibleNav() {
    $('.main-menu')
      .find('li')
      .each(function() {
        var $el = $(this);
        if ($el.hasClass('is-dropdown-submenu-parent')) {
          var $submenu = $el.find('.submenu');
          var $siblings = $el.siblings();
          var $openSubmenus = $siblings.find('.submenu');
          $el.focusin(function() {
            if ($windowWidth > 1024) {
              $el.addClass('is-active');
              $submenu.addClass('js-dropdown-active');
              $siblings.removeClass('is-active');
              $openSubmenus.removeClass('js-dropdown-active');
            }
            if ($(window).width() < 1025) {
              $submenu.removeClass('js-dropdown-active');
              $el.removeClass('is-active');
            }
          });
        } else {
          if (!$el.hasClass('is-dropdown-submenu-parent')) {
            $el.focusin(function() {
              $el
                .siblings()
                .removeClass('is-active')
                .find('.submenu')
                .removeClass('js-dropdown-active');
            });
          }
        }
      });
    // Close Mobile Menu after tabbing through it
    if ($windowWidth < 1025) {
      var $close = $('.top-bar').find('.btn-close-menu');
      $('.closing-mobile-menu').focusin(function() {
        $close.trigger('click');
        $('.menu-icon').focus();
      });
    }
    $('.closing-global-navigation').focusin(function() {
      $('.nav-global-menu-icon').trigger('click');
      $('.nav-global-menu-icon').focus();
    });
  },

  slickSliders() {
    $('.masthead-home').slick({
      accessibility: false,
      arrows: true,
      dots: true,
      autoplay: true,
      fade: true,
      autoplaySpeed: 5000,
      speed: 1000,
      appendDots: $('.mh-dots'),
      nextArrow: $('.slick-next'),
      cssEase: 'linear',
      customPaging: function(slick,index) {
        return '<button tabindex="-1">' + (index + 1) + '</button>';
      }
    });

    $('.feature-widget-slider').slick({
      accessibility: false,
      arrows: false,
      dots: true,
      fade: false,
      appendDots: $('.slick-arrows.feature-widget-slider-nav')
    });

    this.gridToMobileCarousel('.feature-slider', 1, 3);
    //WCAG Chnage - MastHead Play and Pause
    $('.slick-playpause').on('click', function(){
      if ($('.slick-playpause').hasClass('paused')){
        $(".masthead-home").slick('slickPlay');
      } else {
        $(".masthead-home").slick('slickPause');
      }
      $('.slick-playpause').toggleClass('paused');
    });
  },

  filteredSliders() {
    var $focusedImage = $('.focused-image');

    $focusedImage.not('.slick-initialized').slick({
      accessibility: false,
      lazyLoad: 'progressive',
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      infinite: true,
      swipeToSlide: true,
      autoplay: false,
      asNavFor: '.focused-image-nav',
    });

    var $focusedImageNav = $('.focused-image-nav');

    $focusedImageNav.not('.slick-initialized').slick({
      accessibility: false,
      lazyLoad: 'progressive',
      slidesToShow: 3,
      slidesToScroll: 3,
      asNavFor: '.focused-image',
      dots: true,
      arrows: true,
      adaptiveHeight: true,
      fade: false,
      centerMode: false,
      focusOnSelect: true,
      infinite: true,
      swipeToSlide: true,
      variableWidth: true,
      speed: 500,
      appendArrows: $('.slick-arrows'),
      prevArrow: $('.prev'),
      nextArrow: $('.next'),
      appendDots: $('.slick-arrows')
    });

    if ($(window).width() < 1025) {
      $focusedImage.slick('slickUnfilter');
      $focusedImageNav.slick('slickUnfilter');
    } else {
      if ($(window).width() > 1024) {
        $focusedImage
          .slick('slickUnfilter')
          .slick('slickFilter', '.large-slide.slide');
        $focusedImageNav
          .slick('slickUnfilter')
          .slick('slickFilter', '.large-slide.slide');
      }
    }
  },

  pushSlider() {
    var $pushSlider = $('.push-slider');
    $pushSlider.not('.slick-initialized').slick({
      acessibility: false,
      autoplay: false,
      dots: true,
      fade: false,
      arrows: true,
      responsive: [
        {
          breakpoint: 641,
          settings: {
            slidesToShow: 1
          }
        },
        {
          breakpoint: 1025,
          settings: 'unslick'
        },
        {
          breakpoint: 99999,
          settings: 'unslick'
        }
      ]
    });
  },

  pushFooterSlider() {
    if(!window.document.documentMode) {
      var $pushSlider = $('.push-footer-slider');
      $pushSlider.not('.slick-initialized').slick({
        acessibility: false,
        autoplay: false,
        dots: true,
        fade: false,
        arrows: true,
        appendArrows: $('.slick-arrows.push-footer-slider-nav'),
        prevArrow: $('.prev'),
        nextArrow: $('.next'),
        appendDots: $('.slick-arrows.push-footer-slider-nav'),
        responsive: [
          {
            breakpoint: 641,
            settings: {
              slidesToShow: 1
            }
          },
          {
            breakpoint: 1025,
            settings: 'unslick'
          },
          {
            breakpoint: 99999,
            settings: 'unslick'
          }
        ]
      });
    }
  },

  gridToMobileCarousel(gridWrap, mobile, tablet) {
    var $gridWrap = $(gridWrap);
    $gridWrap.not('.slick-initialized').slick({
      acessibility: false,
      autoplay: false,
      dots: true,
      fade: false,
      arrows: true,
      responsive: [
        {
          breakpoint: 641,
          settings: {
            slidesToShow: mobile
          }
        },
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: tablet
          }
        },
        {
          breakpoint: 99999,
          settings: 'unslick'
        }
      ]
    });
  },

  // Remove tags with no content. Temporarily needed for empty tags within CMS Content and WCAG compliance
  removeEmptyTags() {
    var els = document.querySelectorAll('h1, h2, h3, h4, p, li'),
      el;
    for (var i = 0; i < els.length; i++) {
      el = els[i];
      if (!el.firstChild) {
        el.parentNode.removeChild(el);
      }
    }
  },

  hpVideo() {
    
    var playButton = document.getElementById('btn-play');
    var playButton2 = document.getElementById('btn-play-2');
    var playButton3 = document.getElementById('btn-play-3');
    var iframVideo = document.getElementById('iframe_video');
    var closeButton = document.getElementById('video-close');
    var hpVideo = document.getElementById('hp-video');
    var videoSection = document.getElementById('video-section');
    var videoParent = document.querySelector('.making-memories');
    

    if (hpVideo) {
      if (playButton !== null) {
        playButton.addEventListener('click', function() {
          videoParent.style.zIndex = '1002';
          if (hpVideo.paused == true) {
            // Play the video
            videoSection.classList.add('video-playing');
            hpVideo.play();
            /*document.getElementById("iframe_video").pause();*/
          } else {
            // Pause the video
            hpVideo.pause(); 
          }
        });
      }      
      if (playButton2 !== null) {
        playButton2.addEventListener('click', function() {
          videoParent.style.zIndex = '1002';
          if (hpVideo.paused == true) {
            // Play the video
            videoSection.classList.add('video-playing');
            hpVideo.play();
          } else {
            // Pause the video
            hpVideo.pause();
          }
        });
      }
      if (playButton3 !== null) {
        playButton3.addEventListener('click', function() {
          videoParent.style.zIndex = '1002';
          if (hpVideo.paused == true) {
            // Play the video
            videoSection.classList.add('video-playing');
            hpVideo.play();            
          } else {
            // Pause the video
            hpVideo.pause();
          }
        });
      } 
      closeButton.addEventListener('click', function() {
        videoParent.style.zIndex = '1';
        videoSection.classList.remove('video-playing');
        // Pause the video
        hpVideo.pause();
        hpVideo.currentTime = 0;
      });
    }

    //iframVideo
    if (iframVideo) {



      if (playButton !== null) {
        playButton.addEventListener('click', function() {
          videoParent.style.zIndex = '1002';      
          videoSection.classList.add('video-playing');
          $(iframVideo)[0].contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
        });
      } 
      if (playButton3 !== null) {
        playButton3.addEventListener('click', function() {
          videoParent.style.zIndex = '1002';
          videoSection.classList.add('video-playing');
          $(iframVideo)[0].contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
        });
      } 
      closeButton.addEventListener('click', function() {
        videoParent.style.zIndex = '1';
        videoSection.classList.remove('video-playing');
        $(iframVideo)[0].contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
      });
    }


  },

  loadClasses() {

    
    $(
      '.home .masthead, .home .push-booking .console-wrap, .property-navigation .main-menu'
    )
      .addClass('fade-in')
      .css('opacity', '1');
    $('.home .top-bar-left, .home .top-bar-right')
      .delay(500)
      .queue(function() {
        $(this).addClass('fade-in');
      });
  },

  loadEvents() {
    $(window).on('load', function() {
      header.loadClasses();
    });
  },

  resizeEvents() {
    $(window).resize(function() {
      header.accessibleNav();
      header.stickyHeader();
      header.stickySidebar();
      header.responsiveClasses();
      header.gridToMobileCarousel('.feature-slider', 1, 3);
      header.pushSlider();
      header.filteredSliders();
      header.pushFooterSlider();
      header.hpVideo();
    });
  },

  scrollEvents() {
    $(window).scroll(function() {
      header.stickyHeader();
      header.stickySidebar();
    });
    $('.back-to-top').on('click', '.back-to-top-button', function() {
      $('.find-a-hotel-content').css("position", "fixed");
      setTimeout(function(){
        $('.find-a-hotel-content').css("position", "relative");
      }, 200);
    });
  }
};
$('.guest-describe .checkbox-grp .checkbox').on( "click", function() {
  if($('#other').prop("checked") == true && $('.other-inputs').hasClass('hidden') == true){
    $('.other-inputs').removeClass('hidden');
    $('#other_desc').addClass('required');
    $('#other_desc').attr("data-parsley-required","");
  }
  else if($('#other').prop("checked") == false && $('.other-inputs').hasClass('hidden') != true){
    $('.other-inputs').addClass('hidden');
    $('#other_desc').removeClass('required');
    $('#other_desc').removeAttr("data-parsley-required");
  }
});


/* Share Toggle Only for iphone|ipod|ipad*/
$(document).ready(function(){
	var deviceAgent = navigator.userAgent.toLowerCase();
	var agentID = deviceAgent.match(/(iphone|ipod|ipad)/);
	if (agentID) {

    $(document).ready(function(){
        $('.toggle-button').click(function(event){
            event.stopPropagation();
            $(".main_overlay").slideToggle("fast");
        });
        $(".main_overlay").on("click", function (event) {
            event.stopPropagation();
        });
    });
    
    $(document).on("click touchend", function () {
        $(".main_overlay").hide();
    });
    
    $('.main_overlay').on("click touchend", function () {
      if ($('.toggle-content').is(':visible')) {    
        $('.toggle-parent, .toggle-button').removeClass('expanded');
        $('.toggle-content')
          .find(
            'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), button:not(".toggle-button")'
          )
          .attr('tabindex', '0');
        $('.toggle-button').attr('aria-expanded', 'false');
        
      }
    });  
 
	}
});
/* Share Toggle Only for iphone|ipod|ipad*/

header.init();
